<template>
  <div class="concept-taxes">
    <h5 class="title is-5">
      Documentos Relacionados
    </h5>
    <BTooltip
      label="Agregar partida"
      type="is-success"
    >
      <a
        v-if="!disabled"
        class="button add-concept is-success is-rounded"
        @click="addRow"
      >
        <BIcon icon="plus" />
        <span>
          &emsp;
          Agregar Documento
        </span>
      </a>
    </BTooltip>
    <div class="detail-title-container mt-2">
      <div
        v-if="!disabled"
        class="is-centered is-12"
      >
        <BTable
          :data="fixedDocumentsRelated"
          :columns="columns"
        >
          <template
            slot="header"
            slot-scope="props"
          >
            <span :class="{ 'header-label': props.column.label === 'SKU' }">
              {{ props.column.label }}
            </span>
            <AppTooltip
              v-if="props.column.meta"
              :label="props.column.meta"
            />
          </template>
          <template slot-scope="props">
            <BTableColumn
              class="limit-300"
              field="search"
              internal
            >
              <Searcher
                id="documentId"
                name="documentId"
                :required="true"
                :invoice-id="props.row.documentId"
                @selected="setInvoiceValues($event, props.row.id)"
              />
            </BTableColumn>
            <BTableColumn
              field="partiality"
              internal
            >
              <AppInputField
                name="documentPartialityNumber"
                placeholder="1"
                min="0.01"
                step="0.01"
                type="number"
                :disabled="loading || disabled"
                :value="props.row.documentPartialityNumber"
                :required="true"
                @input="onChange($event, props.row.id)"
                @change="onChange($event, props.row.id)"
              />
            </BTableColumn>
            <BTableColumn
              field="currency"
              internal
            >
              <AppInputField
                name="documentCurrency"
                :value="props.row.documentCurrency"
                disabled
                :required="true"
                @input="onChange($event, props.row.id)"
                @change="onChange($event, props.row.id)"
              />
            </BTableColumn>
            <BTableColumn
              field="amount"
              internal
            >
              <AppInputField
                name="documentPreviousBalance"
                placeholder="1"
                min="0.01"
                step="0.01"
                type="number"
                :disabled="loading || disabled"
                :value="props.row.documentPreviousBalance"
                :required="true"
                @input="onChange($event, props.row.id)"
                @change="onChange($event, props.row.id)"
              />
            </BTableColumn>
            <BTableColumn
              field="amountPaid"
              internal
            >
              <AppInputField
                name="documentAmountPaid"
                placeholder="1"
                min="0.01"
                step="0.01"
                type="number"
                :disabled="loading || disabled"
                :value="props.row.documentAmountPaid"
                :required="true"
                @input="onChange($event, props.row.id)"
                @change="onChange($event, props.row.id)"
              />
            </BTableColumn>
            <BTableColumn
              field="OutstandingBalance"
              internal
            >
              <AppInputField
                name="documentOutstandingBalance"
                placeholder="1"
                type="number"
                step="0.01"
                min="0.00"
                :max="String(props.row.documentPreviousBalance)"
                :disabled="loading || disabled"
                :value="calc(props.row)"
                :required="true"
                @input="onChange($event, props.row.id)"
                @change="onChange($event, props.row.id)"
              />
            </BTableColumn>
            <BTableColumn
              field="actions"
              internal
            >
              <span class="actions">
                <a
                  v-if="documents.length > 1"
                  class="button is-danger"
                  @click="deleteRow(props.row.id)"
                >
                  <BIcon
                    icon="delete"
                    aria-hidden="true"
                  />
                </a>
              </span>
            </BTableColumn>
          </template>
          <template
            slot="footer"
          >
            <th colspan="3" />
            <th>
              Total
            </th>
            <th>
              <span>
                {{ total() }}
              </span>
            </th>
            <th />
          </template>
        </BTable>
      </div>
      <div class="wrapper-invoice-totals">
        <BTable>
          <template slot="footer">
            <div class="totals">
              <tr>
                <th
                  scope="col"
                  colspan="1"
                />
                <th
                  scope="col"
                  class="has-text-right"
                >
                  Impuestos
                </th>
                <th
                  scope="col"
                >
                  <span>
                    {{ totalTaxesTransfers() }}
                  </span>
                </th>
              </tr>
              <tr>
                <th
                  scope="col"
                  colspan="1"
                />
                <th
                  scope="col"
                  class="has-text-right"
                >
                  Retenciones
                </th>
                <th
                  scope="col"
                >
                  <span>
                    {{ totalTaxesRetained() }}
                  </span>
                </th>
              </tr>
              <tr>
                <th
                  scope="col"
                  colspan="1"
                />
                <th
                  scope="col"
                  class="has-text-right"
                >
                  Total
                </th>
                <th
                  scope="col"
                >
                  {{ total() }}
                </th>
              </tr>
            </div>
          </template>
        </BTable>
      </div>
    </div>
  </div>
</template>

<script>
import merge from 'lodash/merge';

import {
  mapMutations,
  mapActions,
  mapState,
  mapGetters,
} from 'vuex';

import {
  wayTopay,
  keyUnit,
  currency,
} from '@machete/common-catalogs';

import paymentsHelper from '../../../../lib/paymentsHelper';
import utils from '../../../../lib/utils';

const arrayToOptions = array => array.map(
  ({ key, value }) => ({
    value: key,
    label: `${key} - ${value}`,
  }),
);
export default {
  name: 'NewDocumentRelated',
  components: {
    AppInputField: () => import(/* webpackChunkName: "app-input-field" */ '@/components/AppInputField'),
    Searcher: () => import(/* webpackChunkName: "new-document-related-search" */ '@/components/Admin/Invoices/NewDocumentRelated/NewDocumentRelatedSearch.vue'),
  },
  props: {
    id: { type: Number, default: 0 },
    documents: { type: Array, default: () => ([]) },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      paymentTypeCatalog: arrayToOptions(wayTopay),
      currencyCatalog: arrayToOptions(currency),
      unitKeyCatalog: keyUnit.map(
        ({ key, value }) => ({ value: key, label: `${key} - ${value}` }),
      ),
      columns: [
        {
          label: 'Factura (PPD)',
          field: 'search',
          centered: true,
        },
        {
          label: 'No. de Parcialidad',
          field: 'partiality',
          centered: true,
        },
        {
          label: 'Moneda',
          field: 'currency',
          centered: true,
        },
        {
          label: 'Saldo Anterior',
          field: 'amount',
          width: 150,
          centered: true,
        },
        {
          label: 'Importe a Pagar',
          field: 'amountPaid',
          centered: true,
        },
        {
          label: 'Saldo Insoluto',
          width: 200,
          field: 'OutstandingBalance',
          centered: true,
        },
        {
          label: '',
          field: 'actions',
          centered: true,
        },
      ],
    };
  },
  computed: merge(
    mapState({
      documentsRelated: ({ invoice }) => invoice.complement.payments[0].documentsRelated,
      paymentCurrency: state => state.invoice.complement.payments[0].currency,
    }),
    mapGetters({
      fixedDocumentsRelated: 'invoice/fixedDocumentsRelated',
      fixedPayments: 'invoice/fixedPayments',
    }),
  ),
  methods: merge(
    mapMutations({
      addDocument: 'invoice/addDocument',
      setDocumentValue: 'invoice/updateDocument',
      deleteDocument: 'invoice/deleteDocument',
      setDocumentValues: 'invoice/setDocumentValues',
      setPayment: 'invoice/setPaymentFromDoc',
    }),
    mapActions({
      getCatalog: 'ui/getCatalog',
      searchInvoices: 'invoices/searchInvoices',
    }),
    {
      currencyDecimals() {
        const paymentCurrency = currency.find(
          ({ key }) => key === this.$store.state.invoice.complement.payments[this.id - 1].currency,
        );

        return paymentCurrency.decimals;
      },
      total() {
        const payment = this.$store.state.invoice.complement.payments[this.id - 1];

        const sum = payment.documentsRelated.reduce((accum, documentRelated) => {
          const amount = Number(documentRelated.documentAmountPaid)
            / Number(documentRelated.documentExchangeRate);

          return accum + Number(amount);
        }, 0);

        this.setPayment({
          paymentIndex: this.id,
          accessor: 'amount',
          value: sum.toFixed(this.currencyDecimals()),
        });

        const string = sum.toLocaleString('es-MX', {
          style: 'currency',
          currency: this.$store.state.invoice.complement.payments[this.id - 1].currency || 'MXN',
        });

        return string;
      },
      totalTaxesTransfers() {
        const payment = this.fixedPayments[this.id - 1];

        const { transfers } = payment.taxes;

        const sum = transfers.reduce((accum, tax) => (
          accum + Number(tax.amount)
        ), 0);

        return utils.standardRounding(sum, this.paymentCurrency);
      },
      totalTaxesRetained() {
        const payment = this.fixedPayments[this.id - 1];

        const { retained } = payment.taxes;

        const sum = retained.reduce((accum, tax) => (
          accum + Number(tax.amount)
        ), 0);

        return utils.standardRounding(sum, this.paymentCurrency);
      },
      calc(row) {
        if (row.documentPreviousBalance !== '' && row.documentAmountPaid !== '') {
          const sum = (row.documentPreviousBalance - row.documentAmountPaid)
            .toFixed(this.currencyDecimals());

          this.setDocumentValue({
            accessor: 'documentOutstandingBalance',
            value: sum,
            index: row.id,
            payment: this.id,
          });

          return sum;
        }
        return '';
      },
      addRow() {
        this.addDocument({
          index: this.id,
          document: paymentsHelper.documentTemplate(),
        });
      },
      deleteRow(index) {
        this.deleteDocument({ paymentIndex: this.id, documentIndex: index });
      },
      onChange(event, documentId) {
        const { name: accessor, value } = event.target;

        this.setDocumentValue({
          accessor,
          value,
          index: documentId,
          payment: this.id,
        });

        if (event.cfdi) {
          this.$store.dispatch('customers/getSingleForRep', event.cfdi.operation.customer);
        }
      },
      async searchCreditNote(uuid) {
        const list = await this.searchInvoices({
          filter: 'creditNote',
        });

        return list.length ? list
          .filter(invoices => (invoices.cfdi.cfdisRelated
            && invoices.cfdi.cfdisRelated[0]
            && invoices.cfdi.cfdisRelated[0].uuids[0] === uuid))
          .reduce((accum, invoices) => (
            accum + Number(invoices.cfdi.voucherTotal)
          ), 0) : 0;
      },
      async setInvoiceValues(event, documentId) {
        const { payments } = event.cfdi.operation;

        const totalCreditNotes = await this.searchCreditNote(
          event.cfdi.complement.digitalTaxStamp.uuid,
        );

        const documentPreviousBalance = payments.reduce(
          (acum, { amount }) => acum - Number(amount), event.cfdi.voucherTotal - totalCreditNotes,
        );

        const partiality = (payments.length + 1) || 1;

        this.setDocumentValue({
          accessor: 'documentId',
          value: event.uuid,
          index: documentId,
          payment: this.id,
        });

        this.setDocumentValue({
          accessor: 'documentSeries',
          value: event.cfdi.voucherSeries,
          index: documentId,
          payment: this.id,
        });

        this.setDocumentValue({
          accessor: 'documentConsecutive',
          value: event.cfdi.voucherConsecutive,
          index: documentId,
          payment: this.id,
        });

        this.setDocumentValue({
          accessor: 'documentPartialityNumber',
          value: partiality,
          index: documentId,
          payment: this.id,
        });

        this.setDocumentValue({
          accessor: 'documentPreviousBalance',
          value: documentPreviousBalance.toFixed(this.currencyDecimals()),
          index: documentId,
          payment: this.id,
        });

        this.setDocumentValue({
          accessor: 'documentCurrency',
          value: event.cfdi.voucherCurrency,
          index: documentId,
          payment: this.id,
        });

        this.setDocumentValue({
          accessor: 'documentInvoiceExchangeRate',
          value: event.cfdi.voucherExchangeRate,
          index: documentId,
          payment: this.id,
        });

        this.setDocumentValue({
          accessor: 'documentTotal',
          value: event.cfdi.voucherTotal,
          index: documentId,
          payment: this.id,
        });

        this.setDocumentValue({
          accessor: 'documentTaxTransfers',
          value: paymentsHelper.createTransfersDocumentRelated(event.cfdi.concepts),
          index: documentId,
          payment: this.id,
        });


        this.setDocumentValue({
          accessor: 'objectImpDr',
          value: paymentsHelper.setObjectImpDr(event.cfdi.concepts),
          index: documentId,
          payment: this.id,
        });

        if (event.cfdi.taxes && event.cfdi.taxes.retained) {
          this.setDocumentValue({
            accessor: 'documentTaxWithholdings',
            value: paymentsHelper.createRetainedDocumentRelated(event.cfdi.concepts),
            index: documentId,
            payment: this.id,
          });
        }

        this.$store.dispatch(
          'customers/getSingleForRep',
          event.cfdi.operation.customer,
        );

        this.$store.commit('invoice/setValue', {
          accessor: 'complement.payments[0].currency',
          value: event.cfdi.voucherCurrency,
        });
      },
    },
  ),
};
</script>

<style scoped>

.detail-title-container {
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

.new-tax {
  margin-bottom: 0!important;
  margin-right: .5rem;
}

.new-tax.fee {
  display: flex;
  flex-direction: column-reverse;
  position: relative;
}

.title.is-5 {
  margin-bottom: 0.5em;
  float: left;
}
.limit-300 {
  width: 400px;
}

.totals {
  float: right;
}

.totals th {
  border: 0px;
}
</style>

<style>
.new-tax.fee .help {
  position: absolute;
  top: -1.25rem;
  width: 100%;
  text-align: right;
}
.concept-taxes {
  vertical-align: middle;
  text-align: right;
}
</style>
